export default __webpack_public_path__ + "static/media/300x250-1.1064b7b1.gif";